export function initOgoComparison(scope = document) {
  const sections = scope.querySelectorAll('[data-ogo-comparison]');

  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.ogoComparisonInitialized === 'true') return;

    section.dataset.ogoComparisonInitialized = 'true';

    let isDragging = false;

    const setSplitPosition = (clientX) => {
      const rect = section.getBoundingClientRect();

      if (!rect.width) return;

      const x = clientX - rect.left;
      const percentage = (x / rect.width) * 100;
      const clamped = Math.max(0, Math.min(100, percentage));

      section.style.setProperty('--split-pos', `${clamped}%`);
    };

    section.addEventListener('pointerdown', (event) => {
      isDragging = true;
      setSplitPosition(event.clientX);
      section.setPointerCapture(event.pointerId);
    });

    section.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      setSplitPosition(event.clientX);
    });

    const stopDragging = (event) => {
      if (!isDragging) return;
      isDragging = false;
      try {
        section.releasePointerCapture(event.pointerId);
      } catch (e) {}
    };

    section.addEventListener('pointerup', stopDragging);
    section.addEventListener('pointercancel', stopDragging);
  });
}